/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from 'react';
import { Icon, Collapse, Typography } from '@mui/material';
import clsx from 'clsx';
import { Row } from 'global/components/row';
import { get } from 'global/lib/lodash';
import { Text } from '../text';
import { Accordion, PanelsContainer } from './styles';

/**
 * Accordion groups for /account/content and /account/vendors.
 */
export default (props) => {
  const { panels } = props;
  const [state, setState] = useState({
    expanded: get(props, 'defaultPanel', get(panels, '0.id')),
  });

  return (
    <PanelsContainer>
      {!!props.title && (
        <Text type={'title_large'} style={{ marginBottom: 8 }}>
          {props.title}
        </Text>
      )}
      <Accordion>
        {panels.map((panel, i) => {
          const isOpen = state.expanded === panel.id;
          return (
            <div key={panel.id} className={clsx('accordionRow', i !== panels.length - 1 ? 'notLast' : '')}>
              <Row className="titlerow" fullWidth onClick={() => setState((s) => ({ ...s, expanded: s.expanded === panel.id ? '' : panel.id }))}>
                <Typography>{panel.title}</Typography>
                <Icon>{isOpen ? 'expand_less' : 'expand_more'}</Icon>
              </Row>
              <Collapse in={isOpen}>{isOpen && panel.component({})}</Collapse>
            </div>
          );
        })}
      </Accordion>
    </PanelsContainer>
  );
};
